<mat-card>
  <app-card-header
    [title]="title ?? ''"
    [icono]="fechaAlta ? 'photo_library' : 'event_available'"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close(false)"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <!-- Fecha de alta -->
    <app-content-card title="Fecha de alta" icon="event">
      <section class="inputs-group">
        @if (!fechaAlta) {
          <mat-form-field style="width: 100%">
            <mat-label>Fecha de alta</mat-label>
            <input
              readonly
              matInput
              [owlDateTime]="dt1"
              [owlDateTimeTrigger]="dt1"
              [selectMode]="'single'"
              (dateTimeChange)="onDateTimeChange($event)"
              [max]="maxDate"
            />
            <button
              irxBotonIcono
              tooltip="Elegir fecha"
              matSuffix
              [owlDateTimeTrigger]="dt1"
              type="button"
            >
              <mat-icon>calendar_month</mat-icon>
            </button>
          </mat-form-field>
          <owl-date-time #dt1></owl-date-time>
        } @else {
          <p class="fecha-alta">
            <mat-icon>event_available</mat-icon>
            {{ fechaAlta | date: 'dd/MM/yyyy HH:mm' }}
          </p>
        }
      </section>
    </app-content-card>

    <!-- Imágenes -->
    <app-content-card title="Imágenes" icon="photo_camera">
      <section class="inputs-group" style="flex-direction: column">
        <app-upload-file
          [(urls)]="urlImagenes"
          textoBoton="Subir imágenes"
          [allowMultiple]="true"
          [maxFiles]="4"
        ></app-upload-file>
        <small class="ayuda">Hasta 4 imágenes</small>
      </section>
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button
      irxBoton="secundario"
      type="button"
      (click)="dialogRef.close(false)"
    >
      Cancelar
    </button>
    @if (fechaAlta) {
      <button
        irxBoton="principal"
        type="button"
        (click)="onSubmit()"
        [disabled]="loading"
      >
        <mat-icon>check</mat-icon>
        Actualizar
      </button>
    } @else {
      <button
        irxBoton="principal"
        type="button"
        (click)="onSubmit()"
        [disabled]="!selectedFechaAlta || loading"
      >
        <mat-icon>event_available</mat-icon>
        Dar de alta
      </button>
    }
  </mat-card-actions>
</mat-card>
